export default __webpack_public_path__ + "static/media/chessApp2.eeac225e.png";